module.exports = __webpack_public_path__ + "static/hub-logo-3b765a16e61c13435f7e107b4aa41c67.png";